import React from "react";

import Placeholder, { Rect } from "@/components/Skeleton";

const DispensaryMenuItemCardMobileSkeleton: React.FC = () => {
  return (
    <div
      data-testid="dispensary-menu-item-card-skeleton-mobile"
      className="relative bg-white shadow-low rounded p-lg mb-lg"
    >
      <div className="flex mb-lg">
        <div className="flex flex-col mr-lg">
          <Placeholder width="104" height="104">
            <Rect rx="3" ry="3" width="100%" height="100%" />
          </Placeholder>
        </div>
        <div className="flex flex-col flex-1">
          <div className="mb-xs">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="40%" height="100%" />
            </Placeholder>
          </div>
          <div className="mb-xs">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="100%" height="100%" />
            </Placeholder>
          </div>
          <div className="mb-xs">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="60%" height="100%" />
            </Placeholder>
          </div>
          <div className="mb-xs">
            <div className="flex w-[80px]">
              <div className="mr-xs">
                <Placeholder width="100%" height="20">
                  <Rect rx="3" ry="3" width="100%" height="100%" />
                </Placeholder>
              </div>
              <div>
                <Placeholder width="100%" height="20">
                  <Rect rx="3" ry="3" width="100%" height="100%" />
                </Placeholder>
              </div>
            </div>
          </div>
          <div className="mb-lg">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="40%" height="100%" />
            </Placeholder>
          </div>
          <div className="mb-xs">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="60%" height="100%" />
            </Placeholder>
          </div>
          <div className="mb-xs">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="60%" height="100%" />
            </Placeholder>
          </div>
          <div className="mb-xs">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="100%" height="100%" />
            </Placeholder>
          </div>
          <div className="mb-xs">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="100%" height="100%" />
            </Placeholder>
          </div>
        </div>
      </div>
      <div>
        <Placeholder width="100%" height="40">
          <Rect rx="3" ry="3" width="100%" height="100%" />
        </Placeholder>
      </div>
    </div>
  );
};

export default DispensaryMenuItemCardMobileSkeleton;
